import { render, staticRenderFns } from "./edit-vip.vue?vue&type=template&id=cf224b38&scoped=true"
import script from "./edit-vip.vue?vue&type=script&lang=js"
export * from "./edit-vip.vue?vue&type=script&lang=js"
import style0 from "./edit-vip.vue?vue&type=style&index=0&id=cf224b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf224b38",
  null
  
)

export default component.exports